export type Currency = "PLN" | "USD" | "EUR";

// Exchange rates expressed as: 1 unit of currency = X PLN.
// Adjust these values to keep the PLN conversions up to date.
export const EXCHANGE_RATES_TO_PLN: Record<Currency, number> = {
    PLN: 1,
    USD: 3.65,
    EUR: 4.30,
};

export const toPLN = (amount: number, currency: Currency): number =>
    amount * EXCHANGE_RATES_TO_PLN[currency];
